// extracted by mini-css-extract-plugin
export default {"container":"style_container__fnx+q","hidden":"style_hidden__E+5m7"};